<template>
  <div class="attr-add-options props-group">
    <el-form-item v-if="!component.properties.dataSource.enable" label="允许录入内容" label-width="80px">
      <el-checkbox v-model="component.properties.addOptions"></el-checkbox>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'attr-add-options',
  props: ['component']
}
</script>



// WEBPACK FOOTER //
// src/components/form/componentAttr/add-options.vue